import {useTranslation} from '@aboutyou/i18n';
import {Slide} from '@aboutyou/transitions';
import {styled as linariaStyled} from '@linaria/react';
import React, {FC, useState} from 'react';
import sc from 'styled-components';
import {COLORS} from '../../../../../constants/colors';
import {UnstyledButton} from '../../../../atoms/Buttons/UnstyledButton';
import {Icon} from '../../../../atoms/Icon/Icon';
import {GenericIconName} from '../../../../atoms/Icon/IconName';
import {TextInput} from '../../../../atoms/TextInput/TextInput';

export const GenericFilterSearchField: FC<{
  search: string;
  setSearch: (value: string) => void;
  onFocus?: () => void;
  className?: string;
  showDoneButton?: boolean;
  searchPlaceholder: string;
}> = ({
  search,
  setSearch,
  className,
  onFocus,
  showDoneButton = false,
  searchPlaceholder,
}) => {
  const {t} = useTranslation();
  const [isFocused, setIsFocused] = useState(false);

  const onFocusHandler = () => {
    if (onFocus) {
      onFocus();
    }
    setIsFocused(true);
  };

  const onBlurHandler = () => {
    setIsFocused(false);
  };

  return (
    <TextInputWrapper className={className} data-testid="genericSearchField">
      <TextInput
        activeStyle={{
          backgroundColor: COLORS.Grey4,
          borderColor: COLORS.Grey4,
        }}
        onFocus={onFocusHandler}
        onBlur={onBlurHandler}
        componentLeft={{Component: SearchIconComponent, width: 32}}
        onChange={e => setSearch(e.target.value)}
        placeholder={searchPlaceholder}
        value={search}
      />
      <Slide
        mounted={showDoneButton && isFocused}
        direction={'left'}
        duration={500}
      >
        <StyledButton>{t('Done')}</StyledButton>
      </Slide>
    </TextInputWrapper>
  );
};

const SearchIconComponent = () => (
  <SearchIconWrapper>
    <SearchIcon asset={GenericIconName.Search} size={'S'} />
  </SearchIconWrapper>
);

const SearchIcon = linariaStyled(Icon)`
  fill: ${COLORS.Black};
`;

const SearchIconWrapper = sc.div`
  width: 32px;
  height: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

const TextInputWrapper = sc.div`
  box-sizing: border-box;
  width: 100%;
  background-color: ${COLORS.White};
  margin: 0;
  display: flex;
`;

const StyledButton = sc(UnstyledButton)`
  background: none;
  border: none;
  margin-left: 8px;
  color: ${COLORS.Black};
`;
